import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Button } from "@/components/ui/button";
import { Home, Phone } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col">
      <Helmet>
        <title>404 - Page Not Found | Rick's Black Car Service</title>
        <meta name="description" content="The page you're looking for doesn't exist. Return to Rick's Black Car Service homepage or call (210) 296-7409 for assistance." />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <Navbar />
      <main className="flex-1 flex items-center justify-center bg-secondary/30 px-4 pt-20">
        <div className="text-center space-y-8 max-w-2xl">
          <h1 className="text-9xl font-serif font-bold text-primary">404</h1>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-foreground">Page Not Found</h2>
          <p className="text-xl text-muted-foreground">
            Oops! The page you're looking for seems to have taken a detour. Let's get you back on track.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link to="/">
              <Button className="btn-luxury">
                <Home className="w-4 h-4 mr-2" />
                Return to Home
              </Button>
            </Link>
            <a href="tel:+12102967409">
              <Button variant="outline" className="border-primary text-primary hover:bg-primary hover:text-primary-foreground">
                <Phone className="w-4 h-4 mr-2" />
                Call (210) 296-7409
              </Button>
            </a>
          </div>
          <div className="pt-8">
            <p className="text-muted-foreground mb-4">Looking for something specific?</p>
            <div className="flex flex-wrap gap-3 justify-center">
              <Link to="/services" className="text-primary hover:underline">Services</Link>
              <span className="text-muted-foreground">•</span>
              <Link to="/airport-transportation" className="text-primary hover:underline">Airport Service</Link>
              <span className="text-muted-foreground">•</span>
              <Link to="/service-areas" className="text-primary hover:underline">Service Areas</Link>
              <span className="text-muted-foreground">•</span>
              <Link to="/contact" className="text-primary hover:underline">Contact</Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
